import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getLaundrySchedules } from './api';
import { mapDataForClient } from './mapData';

export const LAUNDRY_SCHEDULES = 'laundrySchedules';

export function useLaundrySchedules(resourceId) {
  const tenantId = getTenantIDBasedOnURL();
  
  const { data, isLoading, isFetching, isError } = useQuery(
    [LAUNDRY_SCHEDULES, tenantId, resourceId],
    () => getLaundrySchedules(resourceId),
    {
      enabled: !!resourceId,
    },
  );

  return {
    laundrySchedules: data?.schedules ? mapDataForClient(data?.schedules) : null,
    isLoading,
    isFetching,
    isError,
  };
}
